// Accounts Charts State
import i18n from '@/i18n'

export default {
  accountsChartsList: [],
  fullAccountsChartsList: [],
  accountsChartInfo: {},
  incomeStatementStatus: [
    { text: i18n.t('Not Included'), value: 'Not Included' },
    { text: i18n.t('Revenue'), value: 'Revenue' },
    { text: i18n.t('Other Revenue'), value: 'Other Revenue' },
    { text: i18n.t('Expenses'), value: 'Expenses' },
    { text: i18n.t('Other Expenses'), value: 'Other Expenses' }
  ],
  cashFlowStatus: [
    { text: i18n.t('Not Included'), value: 'Not Included' },
    {
      text: i18n.t('Operating Activities Increase'),
      value: 'Operating Activities Increase'
    },
    {
      text: i18n.t('Investing Activities Increase'),
      value: 'Investing Activities Increase'
    },
    {
      text: i18n.t('Financing Activities Increase'),
      value: 'Financing Activities Increase'
    },
    {
      text: i18n.t('Operating Activities Decrease'),
      value: 'Operating Activities Decrease'
    },
    {
      text: i18n.t('Investing Activities Decrease'),
      value: 'Investing Activities Decrease'
    },
    {
      text: i18n.t('Financing Activities Decrease'),
      value: 'Financing Activities Decrease'
    }
  ],
  balanceSheetStatus: [
    { text: i18n.t('Not Included'), value: 'Not Included' },
    { text: i18n.t('Current Assets'), value: 'Current Assets' },
    { text: i18n.t('Other Current Assets'), value: 'Other Current Assets' },
    { text: i18n.t('Fixed Assets'), value: 'Fixed Assets' },
    { text: i18n.t('Current Liabilities'), value: 'Current Liabilities' },
    { text: i18n.t('Other Current Liabilities'), value: 'Other Current Liabilities' },
    { text: i18n.t('Stockholders Equity'), value: 'Stockholders Equity' }
  ]
}
